import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sampleProductsPath } from '../lib/paths';

export default function HomePage() {
  useEffect(() => {
    document.title = 'Nyafaz Skincare';
  }, []);

  return (
    <main className="page">
      <section className="hero">
        <span className="badge">Nyafaz Skincare</span>
        <h1>Premium skincare, organized by concern.</h1>
        <p>Browse the full demo catalog with search, filters, recommendations and cart checkout.</p>
        <div>
          <Link to={sampleProductsPath('/products')} className="btn">
            Shop Products
          </Link>
        </div>
      </section>
    </main>
  );
}
